import React, { useState, useEffect } from 'react';
import { Layout, Menu, Card, message } from 'antd';
import { UserOutlined, SettingOutlined, DashboardOutlined, FileTextOutlined, CheckSquareOutlined, PlusOutlined, EyeOutlined, HistoryOutlined, RocketOutlined } from '@ant-design/icons';
import { useAuth, api } from '../contexts/AuthContext';
import UserManagement from '../components/admin/UserManagement';
import Dashboard from '../components/admin/Dashboard';
import OrderReview from '../components/admin/OrderReview';
import UserReview from '../components/admin/UserReview';
import AdminManagement from '../components/admin/AdminManagement';
import OperationLogs from '../components/admin/OperationLogs';
import AISettings from '../components/admin/AISettings';

const { Content, Sider } = Layout;

const AdminPage = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('dashboard');
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);

  const isAdmin = user?.role === 'admin';
  const isSuperAdmin = user?.admin_level === 'super';
  const isSeniorAdmin = user?.admin_level === 'senior' || isSuperAdmin;

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        const response = await api.get('/admin/dashboard');
        setDashboardData(response.data.data);
      } catch (error) {
        message.error('获取仪表盘数据失败');
        console.error('获取仪表盘数据失败:', error);
      } finally {
        setLoading(false);
      }
    };

    if (isAdmin) {
      fetchDashboardData();
    }
  }, [isAdmin]);

  const menuItems = [
    {
      key: 'dashboard',
      icon: <DashboardOutlined />,
      label: '仪表盘',
    },
    {
      key: 'order-review',
      icon: <CheckSquareOutlined />,
      label: '订单审核',
    },
    ...(isSeniorAdmin ? [{
      key: 'users',
      icon: <UserOutlined />,
      label: '用户管理',
    }, {
      key: 'user-review',
      icon: <EyeOutlined />,
      label: '用户审核',
    }, {
      key: 'ai-settings',
      icon: <RocketOutlined />,
      label: 'AI模型设置',
    }] : []),
    ...(isSuperAdmin ? [{
      key: 'admins',
      icon: <PlusOutlined />,
      label: '管理员管理',
    }] : []),
    {
      key: 'logs',
      icon: <HistoryOutlined />,
      label: '操作日志',
    },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <Dashboard data={dashboardData} loading={loading} />;
      case 'users':
        return <UserManagement isSeniorAdmin={isSeniorAdmin} />;
      case 'order-review':
        return <OrderReview />;
      case 'user-review':
        return <UserReview />;
      case 'ai-settings':
        return <AISettings />;
      case 'admins':
        return <AdminManagement />;
      case 'logs':
        return <OperationLogs />;
      default:
        return <Dashboard data={dashboardData} loading={loading} />;
    }
  };

  if (!isAdmin) {
    return (
      <div style={{ textAlign: 'center', padding: '100px 0' }}>
        <Card title="无权限访问" style={{ maxWidth: 500, margin: '0 auto' }}>
          <p>您没有管理员权限，无法访问后台管理系统</p>
        </Card>
      </div>
    );
  }

  return (
    <Layout style={{ minHeight: '80vh' }}>
      <Sider width={200} style={{ background: '#f0f2f5' }}>
        <Menu
          mode="inline"
          selectedKeys={[activeTab]}
          style={{ height: '100%', borderRight: 0 }}
          items={menuItems}
          onClick={({ key }) => setActiveTab(key)}
        />
      </Sider>
      <Layout style={{ padding: '0 24px 24px' }}>
        <Content
          style={{
            background: '#fff',
            padding: 24,
            margin: 0,
            minHeight: 280,
          }}
        >
          {renderContent()}
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminPage;